import React from 'react'
import { DollarSign, TrendingUp, TrendingDown, PieChart } from 'lucide-react'

const StatsCards = ({ profile, stats, expensesByCategory }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount)
  }

  const topCategory = Object.entries(expensesByCategory)
    .sort(([,a], [,b]) => b - a)[0]

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {/* Balance Actual */}
      <div className="bg-white overflow-hidden shadow rounded-lg">
        <div className="p-5">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <DollarSign className="h-6 w-6 text-blue-600" />
            </div>
            <div className="ml-5 w-0 flex-1">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  Balance Actual
                </dt>
                <dd className="text-lg font-medium text-gray-900">
                  {formatCurrency(profile?.current_balance || 0)}
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      {/* Total Ingresos */}
      <div className="bg-white overflow-hidden shadow rounded-lg">
        <div className="p-5">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <TrendingUp className="h-6 w-6 text-green-600" />
            </div>
            <div className="ml-5 w-0 flex-1">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  Total Ingresos
                </dt>
                <dd className="text-lg font-medium text-green-600">
                  {formatCurrency(stats.totalIncome)}
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      {/* Total Gastos */}
      <div className="bg-white overflow-hidden shadow rounded-lg">
        <div className="p-5">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <TrendingDown className="h-6 w-6 text-red-600" />
            </div>
            <div className="ml-5 w-0 flex-1">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  Total Gastos
                </dt>
                <dd className="text-lg font-medium text-red-600">
                  {formatCurrency(stats.totalExpenses)}
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      {/* Categoría Principal */}
      <div className="bg-white overflow-hidden shadow rounded-lg">
        <div className="p-5">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <PieChart className="h-6 w-6 text-purple-600" />
            </div>
            <div className="ml-5 w-0 flex-1">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  Mayor Gasto
                </dt>
                <dd className="text-lg font-medium text-gray-900">
                  {topCategory ? topCategory[0] : 'Sin gastos'}
                </dd>
                {topCategory && (
                  <dd className="text-sm text-gray-500">
                    {formatCurrency(topCategory[1])}
                  </dd>
                )}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StatsCards